/*
  user actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\user\saga.js
*/
const actions = {
  USER_FIELDS: 'USER_FIELDS',
  USER_FIELDS_SUCCESS: 'USER_FIELDS_SUCCESS',
  USERS: 'USERS',
  USERS_SUCCESS: 'USERS_SUCCESS',
  USER_LOOKUP: 'USER_LOOKUP',
  USER_LOOKUP_SUCCESS: 'USER_LOOKUP_SUCCESS',
  USER_CREATE: 'USER_CREATE',
  USER_CREATE_SUCCESS: 'USER_CREATE_SUCCESS',
  USER_UPDATE: 'USER_UPDATE',
  USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  USER_MASSUPDATE: 'USER_MASSUPDATE',
  USER_MASSUPDATE_SUCCESS: 'USER_MASSUPDATE_SUCCESS',
  USER_IMPORT: 'USER_IMPORT',
  USER_IMPORT_SUCCESS: 'USER_IMPORT_SUCCESS',
  USER_DELETE: 'USER_DELETE',
  USER_DELETE_SUCCESS: 'USER_DELETE_SUCCESS',
  USER_ERROR: 'USER_ERROR',
  USER_RESET_CHALLENGE_ANSWERS: 'USER_RESET_CHALLENGE_ANSWERS',
  USER_RESET_CHALLENGE_ANSWERS_SUCCESS: 'USER_RESET_CHALLENGE_ANSWERS_SUCCESS',

  //rest of user editor options
  apiUserFields: () => ({
    type: actions.USER_FIELDS,
  }),

  apiUsers: queryString => ({
    type: actions.USERS,
    queryString,
  }),

  apiUserLookup: queryString => ({
    type: actions.USER_LOOKUP,
    queryString,
  }),

  apiUserCreate: createdUser => ({
    type: actions.USER_CREATE,
    createdUser,
  }),

  apiUserUpdate: updatedUser => ({
    type: actions.USER_UPDATE,
    updatedUser,
  }),

  apiUserMassUpdate: updatedUsers => ({
    type: actions.USER_MASSUPDATE,
    updatedUsers,
  }),

  apiUserResetChallengeAnswers: userId => ({
    type: actions.USER_RESET_CHALLENGE_ANSWERS,
    userId,
  }),

  apiUserImport: importedUsers => ({
    type: actions.USER_IMPORT,
    importedUsers,
  }),

  apiUserDelete: deletedUser => ({
    type: actions.USER_DELETE,
    deletedUser,
  }),
};
export default actions;
